/**
 * @generated SignedSource<<32981c2c47016c3483a7d6d3704da623>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportResolutionTable_report$data = {
  readonly filteredReportResolutions: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly anomalyTypes: ReadonlyArray<any | null> | null;
      readonly currentValue: any | null;
      readonly status: string | null;
      readonly updateStatus: string | null;
      readonly responseData: any | null;
      readonly resolutionKind: string | null;
    }>;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "ReportResolutionTable_report";
};
export type ReportResolutionTable_report$key = {
  readonly " $data"?: ReportResolutionTable_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportResolutionTable_report">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "anomalies"
    },
    {
      "kind": "RootArgument",
      "name": "resolutionSection"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ReportResolutionTableRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ReportResolutionTable_report",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "anomalies",
              "variableName": "anomalies"
            },
            {
              "kind": "Variable",
              "name": "status",
              "variableName": "resolutionSection"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "ReportResolutionsConnection",
      "kind": "LinkedField",
      "name": "filteredReportResolutions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportResolution",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anomalyTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updateStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "responseData",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resolutionKind",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "Report",
  "abstractKey": null
};
})();

(node as any).hash = "51ad372d85b12889a36dd580051ac045";

export default node;
